import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pjg6w4hn3e2i">
        <h2 className="text-center font-display text-[1.45rem] font-extrabold uppercase leading-none text-navy sm:text-[2rem]" data-id="element-20" data-mp="avcxel4e1k8y">
          5 PREMIUM <span className="bg-sun px-1 text-navy" data-id="element-21" data-mp="fsv9ulhm6hlp">BONUSES INCLUDED</span>
        </h2>
        <div className="mt-2 space-y-1.5" data-id="element-22" data-mp="1u59mwzi01t4">
          {bonuses.map(bonus => <article key={bonus.number} className="rounded-md border-l-4 border-sun bg-mist px-2.5 py-2" data-id="element-23" data-mp="5wi4urgmchbn">
              <h3 className="font-display text-[0.68rem] font-extrabold uppercase leading-tight text-electric sm:text-[0.86rem]" data-id="element-24" data-mp="3o2502g6e2o16">
                🎁 BONUS {bonus.number} — {bonus.title}
              </h3>
              <p className="mt-0.5 text-[0.78rem] leading-[1.35] text-navy/80 sm:text-[0.92rem]" data-id="element-25" data-mp="1m9ywzejj2yyl">{bonus.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}